/**
 * @ngdoc controllers
 * @memberof mercury.modules.qa.bepoz
 * @name QaBepozProductSummaryCtrl
 * @description A report that replicates the Product summary from the Bepoz back office
 */
angular.module('mercury.modules.qa.bepoz.productsummary')
.controller('QaBepozProductSummaryCtrl', ["$filter", "ProductSummary", "reporttime", "$q", "$scope", "$stateParams", "title", function($filter, ProductSummary, reporttime, $q, $scope, $stateParams, title) {
  reporttime.setAllowedTypes(['day', 'week', 'month', 'year', 'yesterday', 'custom']);
  reporttime.defaultType = 'day';
  reporttime.restrictToCurrent = true;

  title.set('Products Summary');

  $scope.activeStoreId = $stateParams.store ? parseInt($stateParams.store, 10) : 0;
  $scope.startTime = reporttime.start();
  $scope.endTime = reporttime.end();
  $scope.totalNett = 0;

  var loadingPromises = {
    groups: ProductSummary.getProductGroups($scope.activeStoreId),
    stores: ProductSummary.getStores()
  };

  $scope.loading = $q.all(loadingPromises);
  $scope.loading.then(function(result) {
    $scope.groups = result.groups;
    $scope.stores = result.stores;

    $scope.groupSelected(0);
  });

  $scope.groupSelected = function(id) {
    if (id == $scope.activeGroupId) {
      return;
    }

    $scope.activeGroupId = id;

    $scope.productsLoading = ProductSummary.getProductGroupSales(reporttime.start(), reporttime.end(), id, $scope.activeStoreId);
    $scope.productsLoading.then(function(products) {
      $scope.totalNett = $filter('sumof')(products, 'invoices');
      $scope.products = products;
    });
  };
}]);
